import{useState as r,useEffect as t}from"react";const o=()=>{const[o,c]=r(!1);return t((()=>{c(!0)}),[]),o};export{o as useMountedWithRerender};
